export const faqTopics = [
  'general',
  'learn',
  'create',
  'follow_up',
  'manage',
  'organisation',
  //'learningpath',
];

export const faqTopicsDisplay = [
  'general',
  'learn',
  'create',
  'follow_up',
  'manage',
  //'learningpath',
  //'organisation',
];
